/* eslint-disable no-unused-vars */
import React, {useEffect, useState} from "react";
import {shuffle} from "../utils/utils";
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    useSortable,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {
    Box,
    Button,
    Divider, FormControlLabel, FormGroup,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
    Switch, Tooltip
} from "@mui/material";
import {closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors} from "@dnd-kit/core";
import TextFieldsIcon from '@mui/icons-material/TextFields';
import CodeIcon from '@mui/icons-material/Code';
import HelpIcon from '@mui/icons-material/Help';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ActionsComponent from "../components/ActionsComponent";
import globalVars from "../utils/globalVars";

export default function SortlistComponent(props) {
    const [expectedOrder, setExpectedOrder] = useState(props.exercise.elements.map(e => e));
    const [todoState, setTodoState] = useState(shuffle(props.exercise.elements.map(e => e)));
    const [showSolution, setShowSolution] = useState(false);

    function handleShowSolution() {
        setShowSolution(!showSolution)
    }

    const [showFeedback, setShowFeedback] = useState(false);

    function handleShowFeedback() {
        setShowFeedback(!showFeedback)
    }

    return (
        <div>
            <Stack direction="row" spacing={2}>
                <div key={props.index}>
                    <SortableElements
                        elements={todoState}
                        // feedbackMode={props.feedbackMode}
                        feedbackMode={showFeedback ? "mode_feedback" : ""}
                        expectedOrder={expectedOrder}
                    />
                </div>
                <div key={props.index}>
                    {
                        showSolution
                        &&
                        <Box sx={{width: '100%', maxWidth: '50vw', bgcolor: globalVars.solutionMode.on, color: '#33f'}}>
                            <nav aria-label="main mailbox folders">
                                <List>
                                    {
                                        props.exercise.elements.map(
                                            (e, i) =>
                                                <div key={i + "div"}>
                                                    <Divider key={i + "divider"} component="li"/>
                                                    <ListItem key={i + "listItem"} disablePadding>
                                                        <ListItemButton>
                                                            <ListItemText primary={e}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                </div>
                                        )
                                    }
                                </List>
                            </nav>
                        </Box>
                    }
                </div>
            </Stack>
            {/*<Stack direction="row" spacing={2} sx={{padding: '10px', bgcolor: "#f9f9f9", border: "1px solid #eee"}}>*/}
            {/*    <Divider flexItem orientation="vertical"></Divider>*/}
            {/*    <Tooltip*/}
            {/*        title={"Hilfe wird angezeigt"}*/}
            {/*    >*/}
            {/*        <IconButton*/}
            {/*            onClick={props.toggleDrawJSON}*/}
            {/*            variant="outlined"*/}
            {/*            sx={{*/}
            {/*                minHeight: 0,*/}
            {/*                minWidth: 0,*/}
            {/*                textTransform: 'none',*/}
            {/*                padding: '0px 5px 0px 5px'*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            <HelpIcon/>*/}
            {/*        </IconButton>*/}
            {/*    </Tooltip>*/}
            {/*    <Tooltip*/}
            {/*        title={"JSON zu dieser Aufgabe wird angezeigt"}*/}
            {/*    >*/}
            {/*        <IconButton*/}
            {/*            onClick={props.toggleDrawJSON}*/}
            {/*            variant="outlined"*/}
            {/*            sx={{*/}
            {/*                minHeight: 0,*/}
            {/*                minWidth: 0,*/}
            {/*                textTransform: 'none',*/}
            {/*                padding: '0px 5px 0px 5px'*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            <CodeIcon/>*/}
            {/*        </IconButton>*/}
            {/*    </Tooltip>*/}
            {/*    <Tooltip*/}
            {/*        title={"Lesetext zu dieser Aufgabe wird angezeigt"}*/}
            {/*    >*/}
            {/*        <IconButton*/}
            {/*            onClick={props.toggleDrawLesetext}*/}
            {/*            variant="contained"*/}
            {/*            sx={{*/}
            {/*                minHeight: 0,*/}
            {/*                minWidth: 0,*/}
            {/*                textTransform: 'none',*/}
            {/*                padding: '0px 5px 0px 5px'*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            <TextSnippetIcon/>*/}
            {/*        </IconButton>*/}
            {/*    </Tooltip>*/}
            {/*    <Divider flexItem orientation="vertical"></Divider>*/}
            {/*    <FormGroup row>*/}
            {/*        <Tooltip*/}
            {/*            title={"Die Lösung dieser Aufgabe wird angezeigt"}*/}
            {/*        >*/}
            {/*            <FormControlLabel*/}
            {/*                control={*/}
            {/*                    <Switch*/}
            {/*                        onChange={handleShowSolution}*/}
            {/*                        checked={showSolution}*/}
            {/*                        size="small"*/}
            {/*                    />*/}
            {/*                }*/}
            {/*                label="Lösung"*/}
            {/*            />*/}
            {/*        </Tooltip>*/}
            {/*        <Tooltip*/}
            {/*            title={"Feedback für dieser Aufgabe wird angezeigt"}*/}
            {/*        >*/}
            {/*            <FormControlLabel*/}
            {/*                control={*/}
            {/*                    <Switch*/}
            {/*                        onChange={handleShowFeedback}*/}
            {/*                        checked={showFeedback}*/}
            {/*                        size="small"*/}
            {/*                    />*/}
            {/*                }*/}
            {/*                label="Feedback"*/}
            {/*            />*/}
            {/*        </Tooltip>*/}
            {/*    </FormGroup>*/}
            {/*    <Divider flexItem orientation="vertical"></Divider>*/}
            {/*    <Tooltip*/}
            {/*        title={"Lesetext zu dieser Aufgabe wird angezeigt"}*/}
            {/*    >*/}
            {/*        <Button*/}
            {/*            onClick={props.toggleDrawLesetext}*/}
            {/*            variant="outlined"*/}
            {/*            sx={{*/}
            {/*                minHeight: 0,*/}
            {/*                minWidth: 0,*/}
            {/*                textTransform: 'none',*/}
            {/*                padding: '0px 5px 0px 5px'*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            {"Lesetext anzeigen"}*/}
            {/*        </Button>*/}
            {/*    </Tooltip>*/}
            {/*    <Divider flexItem orientation="vertical"></Divider>*/}
            {/*</Stack>*/}
            <ActionsComponent
                onToggleShowSolution={handleShowSolution}
                onToggleShowFeedback={handleShowFeedback}
                {...props}
            />
        </div>
    );
}

function SortableItem(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({id: props.id});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <>
            <Divider component="li"/>
            <ListItem disablePadding ref={setNodeRef} style={style} {...attributes} {...listeners}>
                <ListItemButton>
                    <ListItemText primary={props.id}/>
                </ListItemButton>
            </ListItem>
        </>
    );
}

function SortableElements(props) {
    const [items, setItems] = useState(props.elements);
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );
    const [ok, setOk] = useState(false);
    useEffect(() => {
        let allTrue = items.map((e, i) => props.expectedOrder.indexOf(e) == i).every(Boolean);
        setOk(allTrue)
    }, [items])
    return (
        <Box sx={{
            width: '100%',
            maxWidth: '50vw',
            bgcolor: ((props.feedbackMode == "mode_feedback") ? (ok ? globalVars.feedbackMode.backgroundColor.ok : globalVars.feedbackMode.backgroundColor.notOk) : 'white')
        }}>
            <nav aria-label="main mailbox folders">
                <List>
                    <DndContext
                        sensors={sensors}
                        collisionDetection={closestCenter}
                        onDragEnd={handleDragEnd}
                    >
                        <SortableContext
                            items={items}
                            strategy={verticalListSortingStrategy}
                        >
                            {
                                items.map(
                                    id =>
                                        <SortableItem
                                            key={id}
                                            id={id}
                                            label={(props.feedbackMode == "mode_feedback") ? (props.elements.indexOf(id) + ". " + id) : ("# " + id)}
                                        />
                                )
                            }
                        </SortableContext>
                    </DndContext>
                </List>
            </nav>
        </Box>
    );

    function handleDragEnd(event) {
        const {active, over} = event;
        if (active.id !== over.id) {
            setItems((items) => {
                const oldIndex = items.indexOf(active.id);
                const newIndex = items.indexOf(over.id);

                return arrayMove(items, oldIndex, newIndex);
            });
        }
    }
}
